<template>
    <v-dialog :value="show" max-width="500" persistent>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col class="text-center" cols="12" v-if="isLoading">
                        <br/>
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            size="75"
                        />
                        <br/>
                        <br/>
                        <p>
                            Deine Daten werden übertragen.
                            <br/>
                            Bitte warte einen Augenblick...
                        </p>
                    </v-col>
                    <v-col cols="12" class="text-center" v-else>
                        <br/>
                        <h3>Vielen Dank für Dein Vertrauen!</h3>
                        <p>
                            <br/>
                            Dein Schreiben wurde an die Airline versandt.
                            <br/>
                            Mit einem Klick auf den nachfolgenden Button gelangst Du wieder an den Anfang des Formulars.
                        </p>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn v-if="isResetButtonAvailable" class="secondary" rounded @click.stop="closeDialog">Zurücksetzen</v-btn>
                <v-spacer/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'SubmitDialog',
    props: {
        value: {
            type: Boolean
        },
        isLoading: {
            type: Boolean
        }
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        isResetButtonAvailable()
        {
            return !this.isLoading;
        }
    },
    methods: {
        closeDialog()
        {
            this.show = false;
        }
    }
}
</script>

<style scoped>

</style>